import { render } from "./quotedPrice.vue?vue&type=template&id=4000e773&scoped=true"
import script from "./quotedPrice.vue?vue&type=script&lang=js"
export * from "./quotedPrice.vue?vue&type=script&lang=js"

import "./quotedPrice.vue?vue&type=style&index=0&id=4000e773&scoped=true&lang=css"

import exportComponent from "F:\\LSDC\\trunk\\lsdc-delivery-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4000e773"]])

export default __exports__